<template>
  <section class="bg-off-white py-[56px] pb-[130px]">
    <div class="container-lg px-[10px] lg:px-0 ">
      <div class="mb-[56px] text-center border-b border-very-light-gray">
        <h2 class="text-[24px] font-semibold leading-[32px] pb-[16px] w-max mx-auto after:border-lime-green m-0 relative after:bottom-0 after:absolute after:w-full after:left-0 after:content-[''] after:border-b-[3px]">
          {{ title }} <span class="highlight-green">{{ highlight_title }}</span>
        </h2>
      </div>
      
      <div :id="type" :data-category-slider="type" :data-slider="type" class="h-max">
        <div v-for="category in categories" :key="category.title" class="py-[12px] px-[12px]">
          <a :href="category.link" :title="category.title">
            <div class="bg-white rounded-[8px] flex gap-[8px] h-[115px]">
              <!-- First column: Image -->
              <div class="h-[115px] w-[115px] relative overflow-visible">
                <div class="absolute h-[125px] w-[125px] right-0 bottom-0">
                  <picture>
                    <source :srcset="category.image.webp" media="(max-width: 767px)" type="image/webp">
                    <img
                      :alt="category.title"
                      :data-src="category.image.source"
                      class="absolute inset-0 w-full h-full lazyload object-cover"
                    >
                  </picture>
                </div>
              </div>
              <!-- Second column: Title and Product count -->
              <div class="py-[24px] pr-[24px] flex flex-col gap-[8px] w-2/3 ">
                <p class="text-[20px] leading-[110%] font-medium line-clamp-2">{{ category.title }}</p>
                <p class="text-[14px] leading-[110%] text-light-gray">{{ category.products }} Produkti</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
      <!-- Slider arrows -->
      <div class="flex justify-center gap-[8px] md:pr-[12px] pt-[44px]">
        <button
          :data-slick-arrows-for="'#' + type"
          :title="in18['page_previous']"
          class="slider__arrows-previous bg-gray h-[36px] rounded-[5px] w-[36px] text-black transition-all  hover:bg-light-gray"
          type="button"
        >
          <img src="/shop/images/arrow-down-white.svg" class="rotate-[90deg] mx-auto my-auto" alt="previous arrow">
        </button>
        <button
          :data-slick-arrows-for="'#' + type"
          :title="in18['page_next']"
          class="slider__arrows-forward bg-gray h-[36px] rounded-[5px] w-[36px] text-black transition-all  hover:bg-light-gray"
          type="button"
        >
          <img src="/shop/images/arrow-down-white.svg" class="rotate-[-90deg] mx-auto my-auto" alt="next arrow">
        </button>
      </div>
  </section>
</template>

<script>
import $ from "jquery";
import "slick-carousel";

export default {
  name:  "Categories",
  props: [
    'in18',
    'type',
    'title',
    'highlight_title',
    'categories'
  ],
  mounted() {
    this.activateSlick();
  },
  methods: {
    activateSlick() {
      $(`[data-category-slider='${this.type}']`).slick({
        infinite:       true,
        slidesToShow:   3,
        slidesToScroll: 1,
        arrows:         false,
        dots:           false,
        speed:          600,
        rows:           2, // Two rows
        autoplay:       true,
        autoplaySpeed:  3000,
        responsive:     [
          {
            breakpoint: 1400,
            settings:   {
              slidesToShow:   3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1200,
            settings:   {
              slidesToShow:   2,
              slidesToScroll: 1,
              rows:           2,
            }
          },
          {
            breakpoint: 768,
            settings:   {
              slidesToShow:   1,
              slidesToScroll: 1,
              rows:           2,
            }
          }
        ]
      });

      $(".slider__arrows-prev").on("click", function () {
        let slider = $(this).data('slick-arrows-for');
        $(slider).slick('slickPrev');
      });

      $(".slider__arrows-next").on("click", function () {
        let slider = $(this).data('slick-arrows-for');
        $(slider).slick('slickNext');
      });
    }
  }
};
</script>

<style scoped>
.category-slider {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}

.category-slider__item {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  width: auto !important;
  margin: 5px !important;
}

.category-slider__item:hover {
  transform: translateY(-5px);
}

.category-slider__content {
  display: flex;
  align-items: center; /* Align image and text */
  justify-content: space-between;
}

.category-slider__image-container {
  flex: 0 0 50px; /* Keep image width fixed */
  margin-right: 16px; /* Spacing between image and text */
}

.category-slider__image {
  width: 100%;
  height: auto;
  object-fit: contain; /* Ensure image fits within container */
}

.category-slider__info {
  flex: 1;
  text-align: left; /* Align text to the left */
}

.category-slider__title {
  font-weight: bold;
  font-size: 1rem;
  margin: 0;
}

.category-slider__products {
  color: #777;
  font-size: 0.85rem;
}

.slider-arrows {
  margin-top: 20px;
}

.slider__arrows-prev, .slider__arrows-next {
  transition: background-color 0.3s ease;
}

.slider__arrows-prev:hover, .slider__arrows-next:hover {
  background-color: #555;
  color: white;
}

</style>
